.error-message-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  max-width: 500px;
  margin: 20px auto;
}

.error-icon {
  font-size: 48px;
  margin-bottom: 15px;
}

.error-text {
  font-size: 16px;
  color: #db3333;
  text-align: center;
  margin-bottom: 20px;
  line-height: 1.5;
}

.error-actions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  justify-content: center;
}

.error-retry-button,
.error-close-button {
  padding: 10px 20px;
  font-size: 14px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  text-transform: uppercase;
  transition: background-color 0.2s;
}

.error-retry-button {
  background-color: #355980;
  color: #fff;
}

.error-retry-button:hover {
  background-color: #2c4968;
}

.error-close-button {
  background-color: #ccc;
  color: #333;
}

.error-close-button:hover {
  background-color: #bbb;
}

/* Мобильные устройства */
@media (max-width: 768px) {
  .error-message-container {
    padding: 30px 15px;
    margin: 15px;
  }

  .error-icon {
    font-size: 36px;
  }

  .error-text {
    font-size: 14px;
  }

  .error-retry-button,
  .error-close-button {
    padding: 8px 16px;
    font-size: 12px;
  }
}

